import { IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';
import { IError } from 'interfaces/review/IReviewDataRow';
import { ColumnName } from 'enums/ColumnName';
import { DataKey } from 'enums/DataKey';

export const previousRowConsistencyValidator: IDataGridValidator = {
  validate: (rows: ReviewDataRow[], columns: IDataGridColumnConfiguration[]) => {
    const result: IError[][] = [];
    let prevLivePlayIndex = -1;
    for (let i = 0; i < rows.length; i++) {
      const errors: IError[] = [];
      const row = rows[i];
      if (!row.isWarmup && !row.isDeleted) {
        if (prevLivePlayIndex !== -1) {
          const prevRow = rows[prevLivePlayIndex];
          validatePDex(row, prevRow, errors);
          validateBSide(row, prevRow, errors);
          validateInning(row, prevRow, errors);
        }
        prevLivePlayIndex = i;
      }
      result.push(errors);
    }
    return result;
  },
};

const validatePDex = (row: ReviewDataRow, prevRow: ReviewDataRow, errors: IError[]) => {
  if (row.pitcher.name === prevRow.pitcher.name && row.pitcherDexterity !== prevRow.pitcherDexterity) {
    errors.push({
      dataKey: DataKey.PitcherDexterity,
      errorMessage: `${ColumnName.PitcherDexterity} changed between pitches`,
    });
  }
};

const validateBSide = (row: ReviewDataRow, prevRow: ReviewDataRow, errors: IError[]) => {
  if (row.batter.name === prevRow.batter.name && row.batterDexterity !== prevRow.batterDexterity) {
    errors.push({
      dataKey: DataKey.BatterDexterity,
      errorMessage: `${ColumnName.BattingSide} changed between pitches`,
    });
  }
};

const validateInning = (row: ReviewDataRow, prevRow: ReviewDataRow, errors: IError[]) => {
  // if inning decreased
  if (
    row.inning.inningNumber < prevRow.inning.inningNumber ||
    (row.inning.inningNumber === prevRow.inning.inningNumber && row.inning.isTopInning && !prevRow.inning.isTopInning)
  ) {
    errors.push({
      dataKey: DataKey.Inning,
      errorMessage: `${ColumnName.Inning} decreased`,
    });
  }
};
